import {CELL_BASE_URL, PALLET_BASE_URL} from "../../CONSTANTS";
import { callPostAxios, callPutAxios } from "../common/common";

export const getCellAllRecord = (data) => {
    return callPostAxios(CELL_BASE_URL() + 'getAllRecords', data, 'cellRecords');
};

export const addCell = (data) => {
    return callPostAxios(CELL_BASE_URL() , data, 'Add Record');
};

export const editCell = (uuid, data) => {
    return callPutAxios(CELL_BASE_URL() + uuid , data, 'Edit Record', 'Edit Record');
};

export const getCellByRack = (uuid) => {
    return callPostAxios(CELL_BASE_URL() + "getCellByRack/" + uuid , {}, 'CellOptions');
};
export const getPalletByCell = (uuid) => {
    return callPostAxios(PALLET_BASE_URL() + "getPalletByCell/" + uuid , {}, 'PalletOptions');
};

export const getPalletAllRecord = (data) => {
    return callPostAxios(PALLET_BASE_URL() + 'getAllRecords', data, 'cellRecords');
};

export const addPallet = (data) => {
    return callPostAxios(PALLET_BASE_URL() , data, 'Add Record');
};

export const editPallet = (uuid, data) => {
    return callPutAxios(PALLET_BASE_URL() + uuid , data, 'Edit Record', 'Edit Record');
};

export const getPalletByRack = (uuid) => {
    return callPostAxios(PALLET_BASE_URL() + "getCellByRack/" + uuid , {}, 'CellOptions');
};
